import React from 'react';

function Header() {
  return (
    <header className="sticky top-0 z-50 bg-[#000033] bg-opacity-70 backdrop-blur-md text-white">
      <nav className="container mx-auto flex items-center justify-between p-4">
        <div className="flex items-center">
          <a href="#" className="text-xl font-bold">Lukeuke</a>
        </div>
        <ul className="flex">
          <li className="mr-6">
            <a href="#about" className="text-white hover:text-yellow-500">About</a>
          </li>
          <li className="mr-6">
            <a href="#projects" className="text-white hover:text-yellow-500">Projects</a>
          </li>
          <li className="mr-6">
            <a href="#skills" className="text-white hover:text-yellow-500">Skills</a>
          </li>
          <li>
            <a href="#contact" className="text-white hover:text-yellow-500">Contact</a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;